export * from './detail-task-table-options';
export * from './detail-task-table.component';
